<app-loading [pequeno]="true" *ngIf="cargando"></app-loading>

<ng-container *ngIf="!cargando">
  <p-accordion id="accordionTopesInversion" [multiple]="false" (onOpen)="abrirAcordeon($event)">
    <p-accordionTab header="{{ 'TOPESINVERSION.LBL_TOPESCANAL' | translate }}" [selected]="tabSeleccionado === 'CAN'">
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TOPESINVERSION.LBL_CANAL' | translate }}:</label>
            <label class="lg:col-1 col-6 md:col-8" *ngIf="topeCanal"><strong>{{topeCanal.canal}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TOPESINVERSION.LBL_MONTOMINIMO' | translate }}:</label>
            <label class="lg:col-1 col-6 md:col-8" *ngIf="topeCanal"><strong>{{topeCanal.montoMinimo | dinero:0}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TOPESINVERSION.LBL_MONTOMAXIMO' | translate }}:</label>
            <label class="lg:col-1 col-6 md:col-8" *ngIf="topeCanal"><strong>{{topeCanal.montoMaximo | dinero:0}}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TOPESINVERSION.LBL_PLAZOMINIMO' | translate }}:</label>
            <label class="lg:col-1 col-6 md:col-8" *ngIf="topeCanal"><strong>{{ topeCanal.plazoMinimo }}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TOPESINVERSION.LBL_PLAZOMAXIMO' | translate }}:</label>
            <label class="lg:col-1 col-6 md:col-8" *ngIf="topeCanal"><strong>{{ topeCanal.plazoMaximo }}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
            <label class="lg:col-1 col-6 md:col-8" *ngIf="topeCanal"><strong>{{ topeCanal.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate) }}</strong></label>
          </div>
    </p-accordionTab>
    <p-accordionTab header="{{ 'TOPESINVERSION.LBL_PAGOINTERESES' | translate }}" [selected]="tabSeleccionado === 'INT'">
      <p-table [columns]="columns" [loading]="loading" #dt
               [value]="listadoFrecuencias" selectionMode="single" dataKey="idTopeCanalFrecuencia"
               [paginator]="true" [rows]="10" paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                class="text-center">
              {{ col.header }}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{ row.frecuencia }}</td>
            <td>{{ row.monto }}</td>
            <td>{{ row.descripcion }}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-accordionTab>
  </p-accordion>

  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar()"></button>
    </div>
  </div>
</ng-container>
